export default __webpack_public_path__ + "static/media/ballyhoura_icon.b383b3d4.svg";